import { Link } from "react-router-dom";
import { investChannels } from "../data/channels.js";
import { faviconUrl } from "../lib/cms.js";
import RiskWarning from "../components/RiskWarning.jsx";

export default function Invest() {
  return (
    <>
      <section className="page-header">
        <div className="wrap">
          <div className="eyebrow">Invest with us</div>
          <h1>Three ways to invest alongside Daksfirst.</h1>
          <p className="sub">
            Direct deals, regulated fund vehicles, or operating credit platforms.
            All channels are restricted to professional and institutional investors.
          </p>
        </div>
      </section>

      <RiskWarning />

      <section>
        <div className="wrap">
          <div className="channel-list">
            {investChannels.map((c, i) => (
              <article className="channel" key={i}>
                <div className="channel-head">
                  <div className="channel-num">0{i + 1}</div>
                  <div>
                    <div className="eyebrow">{c.eyebrow}</div>
                    <h2 className="channel-title">{c.title}</h2>
                  </div>
                </div>
                <p className="channel-body">{c.body}</p>

                {c.items && (
                  <div className="channel-items">
                    {c.items.map((it, j) => (
                      <div className="channel-item" key={j}>
                        <span className="ci-label">{it.label}</span>
                        <span className="ci-text">{it.text}</span>
                      </div>
                    ))}
                  </div>
                )}

                <div className="channel-cta">
                  {c.href.startsWith("/") ? (
                    <Link className="btn btn-primary" to={c.href}>{c.cta} →</Link>
                  ) : (
                    <a className="btn btn-primary" href={c.href} target={c.external ? "_blank" : undefined} rel="noopener noreferrer">{c.cta} →</a>
                  )}

                  {c.extLinks && c.extLinks.length > 0 && (
                    <div className="ext-links">
                      <span className="ext-label">Visit</span>
                      {c.extLinks.map((l, k) => (
                        <a
                          key={k}
                          href={l.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`ext-logo-tile ${l.logoBg === "dark" ? "ext-logo-tile-dark" : ""}`}
                          title={l.label}
                          aria-label={`Visit ${l.label}`}
                        >
                          <img src={l.logoSrc || faviconUrl(l.href)} alt={l.label} loading="lazy" />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="reg tight">
        <div className="wrap" style={{ gridTemplateColumns: "1fr", textAlign: "center" }}>
          <div className="cell">
            <p className="muted" style={{ color: "var(--navy-70)", fontSize: 15, maxWidth: "60ch", margin: "0 auto" }}>
              For full fund documentation, audited accounts, AIFM details and recent transaction memos, please request data room access.
            </p>
            <Link to="/data-room" className="btn btn-dark spacer-m">Request data room access</Link>
          </div>
        </div>
      </section>
    </>
  );
}
